import React, { useEffect, useState } from "react";
import { useLocation, useNavigate, useNavigationType } from "react-router-dom";
import { Table, Select } from "antd";
import Search from "antd/es/input/Search";
import PageTitle from "../Common/PageTitle";
import { formatOptionLabel } from "../../common/elements/myCustomSelect";
import useSWRImmutable from "swr/immutable";
import { fetcher, fetcherhn } from "../../services/fectcher";
import useSWR from "swr";
import MyBackdropSpinner from "../../common/elements/myBackdropSpinner";
import dayjs from "dayjs";

const PatientStatus = [
  {
    value: "All",
    label: "All",
  },
  {
    value: "Active",
    label: "Active",
  },
  {
    value: "Deceased",
    label: "Deceased",
  },
  {
    value: "Dealigned",
    label: "Dealigned",
  },
];

 const currentYearString = dayjs().year().toString();

const CoderReviewHome = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const navigateType = useNavigationType();

  const [year, setYear] = useState(currentYearString);
  const [provider, setProvider] = useState(null);
  const [cmsProvider, setCMSProvider] = useState(null);
  const [query, setQuery] = useState("");
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [status, setStatus] = useState("Active");

  const { data: tableData, isLoading: tableDataLoading } = useSWR(
    `getPatientsForCoderWorkFlow?providerGroup=All&Provider=${
      provider || "All"
    }&allignedProvider=${
      cmsProvider || "All"
    }&cmsProvider=All&patientStatus=${status}&performyr=${year}`,
    fetcherhn
  );

  const { data: provList } = useSWRImmutable(
    `getccmdproviders?lob=HN`,
    fetcher
  );
  const { data: cmsProvList } = useSWRImmutable(`getAlignedProvider`, fetcher);
  const { data: alignmentYear } = useSWRImmutable(`GetPerformYr`, fetcherhn);

  const transformedData = alignmentYear?.map((item) => ({
    label: item?.performyr?.toString(),
    value: item?.performyr?.toString(),
  }));

  const onProviderChange = (e) => {
    setProvider(e);
  };

  const onCMSProviderChange = (e) => {
    setCMSProvider(e);
  };

  useEffect(() => {
    if (location.state?.query) {
      setQuery(location.state.query);
    }
    if (location.state?.page) {
      setPage(location.state.page);
    }
    if (location.state?.pageSize) {
      setPageSize(location?.state?.pageSize);
    }

    if (location.state?.provider) {
      const providerOption = provList?.find(
        (option) => option.label === location.state.provider
      );
      setProvider(providerOption ? providerOption.value : null);
    } else {
      setProvider(null);
    }
    if (location.state?.cmsProvider) {
      const cmsProviderOption = cmsProvList?.find(
        (option) => option.label === location.state.cmsProvider
      );
      setCMSProvider(cmsProviderOption ? cmsProviderOption.value : null);
    } else {
      setCMSProvider(null);
    }

    if (location.state?.status) {
      const statusOption = PatientStatus?.find(
        (option) => option.label === location.state.status
      );
      setStatus(statusOption ? statusOption.value : null);
    } else {
      setStatus("Active");
    }

    if (location.state?.year) {
      const yearOption = transformedData?.find(
        (option) => option.label === location.state.year
      );
      setYear(yearOption ? yearOption?.value : null);
    } else {
      setYear(currentYearString);
    }

    if (navigateType === "POP") {
      setStatus("Active");
      setYear(currentYearString);
      setQuery("");
      setPage(1);
      setPageSize(10);
    }
  }, [location.state, navigateType]);

  const columns = [
    {
      title: "Patient Name",
      dataIndex: "patientNamewithDOB",
      width: 400,
      render: (text, record) => {
        // let statusColor = "tw-text-red-600"; // Default to red (Coder Review Not Started)
        // let statusMessage = "(Coder Review Not Started)";

        // if (record?.currentStatus === "Completed") {
        //   statusColor = "tw-text-green-600";
        //   statusMessage = "(Coder Review Completed)";
        // } else if (record?.currentStatus === "Started") {
        //   statusColor = "tw-text-blue-600";
        //   statusMessage = "(Coder Review in Process)";
        // } else if (record?.currentStatus === "Followup") {
        //   statusColor = "tw-text-gray-600";
        //   statusMessage = "(Follow Up Review)";
        // }

        return (
          <>
            <div className="tw-font-medium">
              {formatOptionLabel({ label: record?.patientNamewithDOB })}
            </div>
            <div className="tw-font-medium tw-text-gray-600">{record.mbi}</div>
            {record.gender === "Male" ? (
              <p className="tw-font-medium tw-mb-0 tw-text-gray-500">
                {record.age} / M
              </p>
            ) : (
              <p className="tw-font-medium tw-mb-0 tw-text-gray-500">
                {record.age} / F
              </p>
            )}
            {/* <p className={`tw-mb-0 ${statusColor}`}>{statusMessage}</p> */}
          </>
        );
      },
    },

    {
      title: "CCMD Provider / Group",
      dataIndex: "ccmdProvider",
      render: (text, record) => (
        <>
          <div>{record.ccmdProvider}</div>
          <div className="tw-text-gray-600">{record.providerGroup}</div>
        </>
      ),
    },
    {
      title: "CMS Provider / Group",
      dataIndex: "alignedProvider",
      render: (text, record) => (
        <>
          <div>{record.alignedProvider}</div>
          <div className="tw-text-gray-600">
            {record.cmsAllignedProviderGroup}
          </div>
        </>
      ),
    },
    {
      title: "Current Alignment Date",
      dataIndex: "currentAlignmentDate",
    },
  ];

  const finalResult = tableData
    ? tableData
        .filter((item) => {
          return [
            "patientNamewithDOB",
            "mbi",
            "ccmdProvider",
            "providerGroup",
            "alignedProvider",
            "cmsAllignedProviderGroup",
            "currentAlignmentDate",
          ].some((key) =>
            (
              item[key]?.toString()?.toLowerCase().replace(/_/g, " ") ?? ""
            ).includes(query?.toLowerCase().replace(/_/g, " ") ?? "")
          );
        })
        .map((item) => ({
          ...item,
          key: item.mbi || item.id || `${item.patientNamewithDOB}-${item.age}`,
        }))
    : tableData;

  const handlePageChange = (page, pageSize) => {
    setPage(page);
    setPageSize(pageSize);
  };

  const onYearChange = (e) => {
    setYear(e);
  };

  return (
    <>
      <div className="tw-flex tw-justify-between">
        <PageTitle title="Coder Review" />
        <div className="tw-flex tw-space-x-2 ">
          <Select
            className="tw-w-full"
            showSearch
            allowClear
            placeholder="Select Performance Year..."
            optionFilterProp="children"
            value={year}
            onChange={onYearChange}
            filterOption={(input, option) =>
              (option?.label ?? "").toLowerCase().includes(input.toLowerCase())
            }
            options={transformedData}
          />
          <Select
            className="tw-w-full"
            showSearch
            allowClear
            disabled={cmsProvider ? true : false}
            placeholder="Select CCMD Provider..."
            optionFilterProp="children"
            value={provider ?? null}
            onChange={onProviderChange}
            filterOption={(input, option) =>
              (option?.label ?? "").toLowerCase().includes(input.toLowerCase())
            }
            options={provList}
          />

          <Select
            className="tw-w-full"
            showSearch
            allowClear
            disabled={provider ? true : false}
            placeholder="Select CMS Provider..."
            optionFilterProp="children"
            value={cmsProvider ?? null}
            onChange={onCMSProviderChange}
            filterOption={(input, option) =>
              (option?.label ?? "").toLowerCase().includes(input.toLowerCase())
            }
            options={cmsProvList}
          />

          <Search
            size="middle"
            placeholder="Search"
            value={query}
            allowClear
            onChange={(e) => setQuery(e.target.value)}
          />
          <Select
            className="tw-w-full"
            showSearch
            placeholder="Active"
            optionFilterProp="children"
            defaultValue={PatientStatus[1].value}
            value={status}
            onChange={(e) => setStatus(e)}
            filterOption={(input, option) =>
              (option?.label ?? "").toLowerCase().includes(input.toLowerCase())
            }
            options={PatientStatus}
          />
        </div>
      </div>

      {tableDataLoading ? (
        <MyBackdropSpinner show={tableDataLoading} />
      ) : (
        <Table
          columns={columns}
          dataSource={finalResult}
          pagination={{
            current: page,
            pageSize: pageSize,
            onChange: (page, pageSize) => handlePageChange(page, pageSize),
            showTotal: (total, [from, to]) =>
              `Showing ${from} - ${to} of ${total} items`,
          }}
          onRow={(record) => ({
            className: "tw-cursor-pointer",
            onClick: () => {
              navigate(`patient/${record?.mbi}`, {
                state: {
                  patientData: record,
                  query,
                  page,
                  provider,
                  cmsProvider,
                  status,
                  pageSize,
                  year,
                },
              });
            },
          })}
        />
      )}
    </>
  );
};

export default CoderReviewHome;
